<template>
  <div
    :class="isInline ? 'tw-flex tw-gap-3' : 'tw-grid tw-gap-2 tw-grid-cols-2'"
    class="messenger-select-filter"
  >
    <el-select
      :model-value="filters.user_from"
      :placeholder="$t('common.fields.sender')"
      filterable
      clearable
      class="messenger-select-filter"
      :class="openedThreadData.id === 'all' || isInline ? '' : 'tw-col-span-2'"
      :filter-method="userGroupsFilterMethod"
      @visible-change="handleUserGroupsVisibleChange"
      @change="(payload) => updateFilter('user_from', payload)"
    >
      <el-option-group
        v-for="group in filteredUserGroups.filter(({ users }) => users.length)"
        :key="group.role_name"
        :label="$capitalize(group.role_name)"
      >
        <el-option
          v-for="user in group.users"
          :key="user.id"
          :label="user.fullname"
          :value="user.id"
        />
      </el-option-group>
    </el-select>
    <el-select
      v-if="openedThreadData.id === 'all'"
      :model-value="filters.permit"
      :placeholder="$t('common.fields.permit')"
      filterable
      clearable
      class="messenger-select-filter"
      @change="(payload) => updateFilter('permit', payload)"
    >
      <el-option
        v-for="item in permits"
        :key="item.id"
        :label="`${item.permit_type_name} (${item.reference_number})`"
        :value="item.id"
      >
        <span
          class="tw-w-3 tw-h-3 tw-block tw-mr-2"
          :class="`tw-bg-${item.color}`"
        />
        <span>
          {{ item.permit_type_name }} ({{ item.reference_number }})
        </span>
      </el-option>
    </el-select>
    <el-date-picker
      v-model="filters.date_create_from"
      type="date"
      :placeholder="$t('common.fields.date_from')"
      format="DD.MM.YYYY"
      value-format="DD.MM.YYYY HH:mm:ss"
      @change="(payload) => updateFilter('date_create_from', payload)"
    />
    <el-date-picker
      v-model="filters.date_create_to"
      type="date"
      :placeholder="$t('common.fields.date_to')"
      format="DD.MM.YYYY"
      value-format="DD.MM.YYYY HH:mm:ss"
      @change="(payload) => updateFilter('date_create_to', payload)"
    />
  </div>
</template>

<script>
import { userGroupsFilterMixin } from '@/mixins/userGroupsFilterMixin';
import { mapState } from 'vuex';

export default {
  mixins: [userGroupsFilterMixin],
  props: {
    isInline: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.messaging.filters,
      userGroups: (state) => state.v2.admin.messaging.messagingUsers,
      permits: (state) => state.v2.admin.foreigners.foreigner.permits,
      openedThreadData: (state) => state.v2.admin.messaging.openedThreadData,
    }),
  },

  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/messaging/updateFilter', { field, payload });
    },
  },
};
</script>
